import { required, useGetIdentity, useGetList, useGetOne } from "react-admin";
import { CustomerReadModel } from "../../GeneratedClients/FreeBillApi"
import { useFormContext } from "react-hook-form";
import { CustomAutocompleteInput } from "./CustomAutocompleteInput";
import textModelTemplate from "../../fixtures/textModelTemplate";
import { v4 as uuidv4 } from 'uuid';

const CustomerInput = () => {
  const { data: identity, isLoading: identityLoading } = useGetIdentity()
  const { data: user, isLoading: userLoading} = useGetOne("users", {id: identity?.id})
  const { data: customers, isLoading: customersLoading} = useGetList(
    'customers', 
    {sort: {field: 'company.companyName', order: 'ASC'}, pagination: {page: 1, perPage: 1000}}
  )
  const { setValue } = useFormContext()
  if(identityLoading || userLoading || customersLoading || !identity) return null

  const handleChange = (newCompanyName: string) => {
    const newCustomer: CustomerReadModel = findCustomerByCompanyName(newCompanyName)
    setValues(newCustomer)
  }

  const handleInputChange = (event: any, newInputValue: string) => {
    const existingCustomer = findCustomerByCompanyName(newInputValue)
    if(existingCustomer)
    {
      setValues(existingCustomer)
    }
    else
    {
      const newCustomer: CustomerReadModel = {
        id: uuidv4(),
        company: {
          companyName: newInputValue,
          street: "",
          postCode: "",
          city: "",
          country: "",
        },
        ustId: "",
        textModel: user.textModel ? user.textModel : textModelTemplate
      }
      setValues(newCustomer)
    }
  }

  const setValues = (customer: CustomerReadModel) => {
    setValue('invoiceRecipient', customer)
    const textModel = customer?.textModel ? customer.textModel : (user.textModel ? user.textModel : textModelTemplate)
    setValue('textModel', textModel)
  }

  const findCustomerByCompanyName = (companyName:string) => {
    return customers?.find((customer: CustomerReadModel) => (customer.company?.companyName === companyName))
  }

  return (
    <CustomAutocompleteInput 
      clearOnBlur={false}
      onChange={handleChange}
      onInputChange={handleInputChange}
      fullWidth
      helperText={false}
      validate={required()}
      source="invoiceRecipient.company.companyName"
      optionText="company.companyName"
      optionValue="company.companyName"
      choices={customers}
      label="resources.company.companyName"
    />
  )
}

export default CustomerInput
